import roles from '@/settings/roles';

export default [
  {
    path: 'mail',
    name: 'customer-mail',
    component: () => import(/* webpackPrefetch: true */ '@/views/customer/Mail.vue'),
    meta: {
      forAuth: true,
      roles: [roles.customer]
    },
  },
  {
    path: 'account',
    name: 'customer-account',
    component: () => import(/* webpackPrefetch: true */ '@/views/customer/Account.vue'),
    meta: {
      forAuth: true,
      roles: [roles.customer]
    },
   // alias: 'admin/account'
  },
  {
    path: 'messages',
    name: 'customer-messages',
    component: () => import(/* webpackPrefetch: true */ '@/views/customer/Messages.vue'),
    meta: {
      forAuth: true,
      roles: [roles.customer]
    },
  },
  {
    path: 'notarize-form1583',
    name: 'notarize-form1583',
    component: () => import('@/views/customer/pages/NotarizeForm1583.vue'),
    meta: {
      forAuth: true,
    },
  },
  {
    path: 'notarize-document',
    name: 'notarize-document',
    component: () => import('@/views/customer/pages/NotarizeDocument.vue'),
    meta: {
      forAuth: true,
    },
  },
  // {
  //   path: '/pricing',
  //   name: 'pricing',
  //   component: () => import('@/views/customer/Pricing.vue'),
  //   meta: {
  //     forAuth: true,
  //   },
  // },
  {
    path: 'update-plan',
    name: 'update-plan',
    component: () => import('@/views/customer/pages/account/UpdatePlan.vue'),
    meta: {
      forAuth: true,
    },
  },
  {
    path: 'port-number',
    name: 'port-number',
    component: () => import('@/views/customer/pages/PortNumber.vue'),
    meta: {
      forAuth: true,
    }
  },
  {
    path: 'phone-setup/:id',
    name: 'phone-setup',
    component: () => import('@/views/customer/pages/account/PhoneSetup.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'phone-select',
    name: 'phone-select',
    component: () => import('@/views/customer/pages/account/PhoneSelect.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'tracking',
    name: 'customer-tracking',
    component: () => import('@/views/customer/pages/Tracking.vue'),
    meta: {
      forAuth: true,
    },
  },
]